export const isInCluster = () => !!process.env.KUBERNETES_SERVICE_HOST;
